module.exports = __webpack_public_path__ + "img/HTMLIcon.7b1ac8ab.jpeg";